
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import TravelSelect from '@/components/inputs/TravelSelect.vue';
import ImageUpload from '@/components/inputs/ImageUpload.vue';
import Package from '@/models/package';
import DatePicker from '@/components/inputs/DatePicker.vue';
import moment from 'moment';
import TextEditor from '@/components/inputs/TextEditor.vue';
import { ESPERA_DE_PRECIOS, EsperaDePrecios, MEDIO_SEGUNDO } from '@/helpers/espera-de-precios';

@Component({
	components: {
		TextEditor,
		DatePicker,
		ImageUpload,
		TravelSelect,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class TabTravelPackage extends Vue {
	@Prop({ default: null, required: true }) private package;
	@Prop({ default: null, required: false }) private errors;
	@Inject({ from: ESPERA_DE_PRECIOS, default: null }) private readonly esperaDePrecios!: EsperaDePrecios | null;

	private packageData: any;
	private offer_min_date: any;
	private offer_end_date_max_date: any;
	// N-288 · 4A: la espera de medio segundo tras la última tecla de las personas.
	private temporizadorPersonas: any = null;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
		img_url;
	};

	// @Watch("package")
	// package_change(value) {
	// 	this.copyPackage(value);
	// }

	constructor() {
		super();
		this.packageData = new Package();
		this.offer_min_date = moment()
			.add(2, 'days')
			.format('YYYY-MM-DD');
		this.offer_end_date_max_date = '';
	}

	mounted() {
		if (this.package) {
			this.copyPackage(this.package);
		}
	}

	copyPackage(data) {
		this.packageData = Package.copy(data);
		if (this.packageData.offer) {
			this.setOfferEndDateMax();
		}
	}

	get isImageUploaded() {
		return typeof this.package.img_url === 'string';
	}

	async validateFile($event) {
		await this.$refs['img_url'].validate($event);
	}

	/**
	 * El `@input` de las personas. N-288 · 4A (también en paquetes, 8-oct): antes las personas solo
	 * llegaban a las pestañas al validar (cambiar de pestaña o GUARDAR): al guardar, los catálogos
	 * del número nuevo se pedían a la vez que se mandaba el paquete con los precios del viejo. Ahora llegan medio segundo después de la última tecla, como en «Editar
	 * presupuesto», y mientras tanto GUARDAR espera.
	 */
	personasTecleadas() {
		clearTimeout(this.temporizadorPersonas);
		this.temporizadorPersonas = setTimeout(() => this.soltarPersonas(), MEDIO_SEGUNDO);
		if (this.esperaDePrecios) {
			this.esperaDePrecios.tecleando = parseInt(this.packageData.people);
		}
	}

	soltarPersonas() {
		this.cancelarEsperaDeTeclas();
		this.emitValue();
	}

	cancelarEsperaDeTeclas() {
		clearTimeout(this.temporizadorPersonas);
		this.temporizadorPersonas = null;
		if (this.esperaDePrecios) {
			this.esperaDePrecios.tecleando = null;
		}
	}

	beforeDestroy() {
		this.cancelarEsperaDeTeclas();
	}

	async validate() {
		this.cancelarEsperaDeTeclas();
		this.$emit('input', this.packageData);
		return await this.$refs.obs.validate();
	}

	emitValue() {
		// Esto es porque al cambiar oferta, debe mostrar u ocultrar el precio en el tab
		this.$emit('input', this.packageData);
	}

	setOfferEndDateMax() {
		this.offer_end_date_max_date = moment(this.packageData.offer_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
	}
}
